import { render, staticRenderFns } from "./PointWriteWithdrawLayout.vue?vue&type=template&id=8d5f0822&scoped=true"
import script from "./PointWriteWithdrawLayout.vue?vue&type=script&lang=js"
export * from "./PointWriteWithdrawLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5f0822",
  null
  
)

export default component.exports